import { styled } from '@air/marketing-primitives';

export const Root = styled('footer', {
  backgroundColor: '$pigeon025',
  paddingY: 40,

  '@laptop': {
    paddingY: 80,
  },
});

export const Info = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'row',
  flexGrow: 1,
  flexShrink: 0,
  marginRight: 24,
  justifyContent: 'space-between',

  '@laptop': {
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
});

export const NavigationContainer = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  width: '100%',
  maxWidth: 'unset',

  '@laptop': {
    flexDirection: 'nowrap',
    maxWidth: 900,
  },
});

export const Navigation = styled('nav', {
  display: 'flex',
  flexDirection: 'column',
  width: 'calc(50% - 24px)',
  marginRight: 24,
  marginBottom: 24,

  '@laptop': {
    width: 'auto',
    marginBottom: 24,
  },
});
